// removed by extract-text-webpack-plugin
module.exports = {"button":"button_3JXbH","errorMessage":"errorMessage_2myxe","successMessage":"successMessage_38mru","defaultMessage":"defaultMessage_qqYu2","loader":"loader_2L7lI"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PageActivations/style.css
// module id = 215
// module chunks = 0